import { render } from "./ExpenseReceiptCreateFooterActions.vue?vue&type=template&id=56727480&scoped=true"
import script from "./ExpenseReceiptCreateFooterActions.vue?vue&type=script&lang=js"
export * from "./ExpenseReceiptCreateFooterActions.vue?vue&type=script&lang=js"

import "./ExpenseReceiptCreateFooterActions.vue?vue&type=style&index=0&id=56727480&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56727480"]])

export default __exports__